// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.menubutton {
    display: inline-flex;
    align-items: center;
}

div.menubutton-disabled {
    pointer-events: none;
}

div.menubutton-button {
    position: relative;
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    height: 100%;
    background-color: var(--button-bg-color);
    color: var(--button-text-color);
    border: 1px solid var(--border-color);
}

div.menubutton-disabled div.menubutton-button {
    color: var(--text-color-disabled);
}

div.menubutton-button:active > span.menubutton-button-content,
div.menubutton-button:active > span.menubotton-button-arrow {
    position: relative!important;
    left: 1px;
    top: 1px;
}

div.menubutton-button:hover,
div.menubutton-button-hover {
    background-color: var(--button-bg-color-hover);
    color: var(--button-text-color-hover);
}

div.menubutton-button-active {
    background-color: var(--button-bg-color-active);
    color: var(--button-text-color-active);
}

div.menubutton-button-active:hover,
div.menubutton-button-active.menubutton-button-hover {
    background-color: var(--button-bg-color-active-hover);
    color: var(--button-text-color-active-hover);
}

span.menubutton-button-content {
    padding: 0 0.5em;
    flex: 1 1 auto;
    display: inline-block;
    height: 100%;
    display: flex;
    align-items: center;
}

div.menubutton-menubutton > span.menubotton-button-arrow {
    height: 100%;
    display: flex;
    align-items: flex-end;
    font-size: 80%;
    padding: 0.2em;
}

div.menubutton-togglebutton > span.menubotton-button-arrow {
    padding: 0 0.125em;
    height: 100%;
    display: flex;
    align-items: center;
    border-left: 1px solid var(--border-color);
}

div.menubutton-menu {
    background-color: var(--list-bg-color);
    border: 1px solid var(--border-color);
    color: var(--text-color);
    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);
}

div.menubutton-menu > div {
    padding: 0.25em;
}

div.menubutton-menu > div:hover {
    background-color: var(--list-item-bg-color-hover);
    color: var(--list-item-text-color-hover);
}

div.menubutton-menu > div.menubutton-menu-active {
    background-color: var(--list-item-bg-color-active);
    color: var(--list-item-text-color-active);
}

div.menubutton-menu > div.menubutton-menu-active:hover {
    background-color: var(--list-item-bg-color-active-hover);
    color: var(--list-item-text-color-active-hover);
}

div.menubutton-menu-disabled {
    color: var(--text-color-disabled);
}
`, "",{"version":3,"sources":["webpack://./qwc2/components/widgets/style/MenuButton.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,wCAAwC;IACxC,+BAA+B;IAC/B,qCAAqC;AACzC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;;IAEI,4BAA4B;IAC5B,SAAS;IACT,QAAQ;AACZ;;AAEA;;IAEI,8CAA8C;IAC9C,qCAAqC;AACzC;;AAEA;IACI,+CAA+C;IAC/C,sCAAsC;AAC1C;;AAEA;;IAEI,qDAAqD;IACrD,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,sCAAsC;IACtC,qCAAqC;IACrC,wBAAwB;IACxB,gDAAgD;AACpD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iDAAiD;IACjD,wCAAwC;AAC5C;;AAEA;IACI,kDAAkD;IAClD,yCAAyC;AAC7C;;AAEA;IACI,wDAAwD;IACxD,+CAA+C;AACnD;;AAEA;IACI,iCAAiC;AACrC","sourcesContent":["div.menubutton {\n    display: inline-flex;\n    align-items: center;\n}\n\ndiv.menubutton-disabled {\n    pointer-events: none;\n}\n\ndiv.menubutton-button {\n    position: relative;\n    flex: 1 1 auto;\n    display: flex;\n    align-items: center;\n    height: 100%;\n    background-color: var(--button-bg-color);\n    color: var(--button-text-color);\n    border: 1px solid var(--border-color);\n}\n\ndiv.menubutton-disabled div.menubutton-button {\n    color: var(--text-color-disabled);\n}\n\ndiv.menubutton-button:active > span.menubutton-button-content,\ndiv.menubutton-button:active > span.menubotton-button-arrow {\n    position: relative!important;\n    left: 1px;\n    top: 1px;\n}\n\ndiv.menubutton-button:hover,\ndiv.menubutton-button-hover {\n    background-color: var(--button-bg-color-hover);\n    color: var(--button-text-color-hover);\n}\n\ndiv.menubutton-button-active {\n    background-color: var(--button-bg-color-active);\n    color: var(--button-text-color-active);\n}\n\ndiv.menubutton-button-active:hover,\ndiv.menubutton-button-active.menubutton-button-hover {\n    background-color: var(--button-bg-color-active-hover);\n    color: var(--button-text-color-active-hover);\n}\n\nspan.menubutton-button-content {\n    padding: 0 0.5em;\n    flex: 1 1 auto;\n    display: inline-block;\n    height: 100%;\n    display: flex;\n    align-items: center;\n}\n\ndiv.menubutton-menubutton > span.menubotton-button-arrow {\n    height: 100%;\n    display: flex;\n    align-items: flex-end;\n    font-size: 80%;\n    padding: 0.2em;\n}\n\ndiv.menubutton-togglebutton > span.menubotton-button-arrow {\n    padding: 0 0.125em;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    border-left: 1px solid var(--border-color);\n}\n\ndiv.menubutton-menu {\n    background-color: var(--list-bg-color);\n    border: 1px solid var(--border-color);\n    color: var(--text-color);\n    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);\n}\n\ndiv.menubutton-menu > div {\n    padding: 0.25em;\n}\n\ndiv.menubutton-menu > div:hover {\n    background-color: var(--list-item-bg-color-hover);\n    color: var(--list-item-text-color-hover);\n}\n\ndiv.menubutton-menu > div.menubutton-menu-active {\n    background-color: var(--list-item-bg-color-active);\n    color: var(--list-item-text-color-active);\n}\n\ndiv.menubutton-menu > div.menubutton-menu-active:hover {\n    background-color: var(--list-item-bg-color-active-hover);\n    color: var(--list-item-text-color-active-hover);\n}\n\ndiv.menubutton-menu-disabled {\n    color: var(--text-color-disabled);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
